import _ from 'lodash';
import React, { Suspense, lazy, useEffect } from 'react';

import PubSub from 'pubsub-js';
import { BrowserRouter, Route } from 'react-router-dom';

// import BibRetrAdvance from './component/bibsearch/BibRetrAdvance/BibRetrAdvance';
// import MyLibrary from './component/MyLibrary/MyLibrary';
// import DetailPage from './component/bibsearch/DetailPage/DetailPage';
// import RdrLogout from './component/MyLibrary/RdrLogout';
//import RdrLogin from './component/MyLibrary/RdrLogin';
//import BibRetrieve from './component/bibsearch/BibRetrieve';

import { useSelector } from 'react-redux';

import ULAS from './component/OtherLAS/ulas/ULAS';
// import autoLogin from './publicMethods/autologin';
// for multi language
import {
  useLocalStorageState,
  useRequest,
  useSessionStorageState,
} from 'ahooks';
import 'dayjs/locale/zh-cn';
import 'moment/locale/zh-cn';
import { IntlProvider } from 'react-intl';
import http from '../src/utils/http';
import ar_sa from './locales/ar_sa';
import de from './locales/de';
import en from './locales/en';
import jp from './locales/jp';
import zh_CN from './locales/zh_CN';

const RdrLogin = lazy(() => import('./component/MyLibrary/RdrLogin'));
const BibRetrieve = lazy(() => import('./component/bibsearch/BibRetrieve'));
const ClcRetrieve = lazy(() => import('./component/clcsearch/index'));
const NewBooks = lazy(() => import('./component/newsearch/index'));
const HotBorrow = lazy(() => import('./component/hotsearch/index'));
const Notice = lazy(() => import('./component/notice/index'));

/* const BibRetrAdvance = lazy(
  () => import('./component/bibsearch/BibRetrAdvance/BibRetrAdvance'),
); */
const MyLibrary = lazy(() => import('./component/MyLibrary/MyLibrary'));
const DetailPage = lazy(
  () => import('./component/bibsearch/DetailPage/DetailPage'),
);
const RdrLogout = lazy(() => import('./component/MyLibrary/RdrLogout'));
// const AutoLogin = lazy(()=>import('./publicMethods/AutoLogin'));
/* const metalspStore = lazy(
  () => import('./component/metalsp-store/metalsp-store'),
); */
const DemoBibRetrieve = lazy(() => import('./component/demo/DemoBibRetrieve'));
const TagCloud = lazy(() => import('./component/bibsearch/TagCloud/TagCloud'));
const FakeDetail = lazy(
  () => import('./component/bibsearch/DetailPage/ItemTab/FakeDetail'),
);
const Home = lazy(() => import('./component/home/Home'));
const Link = lazy(() => import('./component/link/Link'));

const DigitalTwins = lazy(
  () => import('./component/TechLib/DigitalTwins/DigitalTwins'),
);

const Application = (props) => {
  // initlize
  const { config, theme } = props;
  const [, setAppConfig] = useSessionStorageState('app-config', {
    defaultValue: { header: '', footer: '' },
  });
  const [parLibMember, setParLibMember] = useLocalStorageState('parLibMember', {
    defaultValue: [],
  });
  const [parLocals, setParLocals] = useLocalStorageState('parLocals', {
    defaultValue: [],
  });
  const [parDocCirculationTypes, setParDocCirculationTypes] =
    useLocalStorageState('parDocCirculationTypes', { defaultValue: [] });

  useRequest(async () => {
    syncConfig();
    parLibMemberosition();
    parLocalsPosition();
    typeName();
  });
  async function syncConfig() {
    const res = await fetch(`/config.json?v=${Date.now()}`);
    const content = await res.json();
    setAppConfig(content);
  }
  // 获取图书的中文典藏地址 书不在典藏馆里，所以没有典藏
  async function parLibMemberosition() {
    http
      .get('/par-lib-members')
      .then((data) => {
        setParLibMember(
          _.get(data, 'parLibMembers', []).map((item) => ({
            libid: item.libId,
            libname: item.libName,
            cirpar: item.cirpar,
          })),
        );
      })
      .catch((err) => {
        throw err;
      });
  }

  //获取图书的原始编码Code
  async function parLocalsPosition() {
    http
      .get(`/par-locals`)
      .then((data) => {
        setParLocals(
          _.get(data, 'parLocals', []).map((item) => ({
            locCode: item.locCode,
            locName: item.locName,
            id: item.id,
          })),
        );
      })
      .catch((err) => {
        throw err;
      });
  }

  async function typeName() {
    http
      .get('/par-doc-cirtypes')
      .then((data) => {
        setParDocCirculationTypes(
          _.get(data, 'parDocCirculationTypes', []).map((item) => ({
            code: item.code,
            name: item.name,
            canrese:item.canrese
          })),
        );
      })
      .catch((err) => {
        throw err;
      });
  }

  const holdingStatus = [
    { value: 'a', label: '采编', stock: true },
    { value: 'b', label: '入藏', stock: true },
    { value: 'c', label: '借出', stock: false },
    { value: 'd', label: '租出', stock: false },
    { value: 'e', label: '预约', stock: true },
    { value: 'f', label: '丢失', stock: false },
    { value: 'g', label: '剔除', stock: false },
    { value: 'j', label: '赠送', stock: true },
    { value: 'h', label: '装订', stock: true },
    { value: 'i', label: '交换', stock: true },
    { value: 'k', label: '调拨', stock: false },
    { value: 'l', label: '互借', stock: false },
    { value: 'm', label: '预借', stock: true },
    { value: 'n', label: '闭架', stock: false },
    { cvalue: 'o', label: '锁定', stock: true },
    { value: 'p', label: '其他', stock: true },
    { value: 'q', label: '在架', stock: true },
  ];

  useEffect(() => {
    PubSub.subscribe('theme', (theme, data) => {
      console.log('theme2222', theme);
      console.log('theme33333', data);
    });
    if (theme === 'light') import('antd/dist/antd.variable.min.css');
    else import('antd/dist/antd.dark.min.css');
  }, [theme]);

  const defaultLang = config.browserDetectLanguage
    ? navigator.language
    : config.locale;
  // const token = config.token;
  const { lang } = useSelector((state) => state.szlib);

  // const [theme, setTheme] = useState(config.theme);

  // const { theme } = useSelector((state) => state.szlibFunction);
  // console.log(theme,'theme111');

  // // function
  // const loginSystem = () => {
  //   if (!_.isEmpty(token))
  //     return ;

  //   // if (!_.isEmpty(window.localStorage.token)) {
  //   //   setToken(token);
  //   //   return ;
  //   // }

  //   const reqPara = {username: config.username, password: config.userpin};
  //   fetch(`${config.okapi.url}/bl-users/login?expandPermissions=true&fullPermissions=true`, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'X-Okapi-Tenant': config.okapi.tenant
  //     },
  //     body: JSON.stringify(reqPara)
  //   })
  //   .then(res => {
  //     const token = res.headers.get('x-okapi-token');
  //     setToken(token);
  //     window.localStorage.token = token;
  //     return res.json();})
  //   .then(data => {
  //     // 这里必须有
  //   });
  // }

  const handleMessages = (lang) => {
    let res = null;
    switch (lang) {
      case 'zh':
      case 'zh-CN':
        res = zh_CN;
        break;

      case 'jp':
        res = jp;
        break;

      case 'en':
      case 'en-US':
        res = en;
        break;

      case 'de':
        res = de;
        break;

      case 'ar-sa':
        res = ar_sa;
        break;

      default:
        res = zh_CN;
    }
    return res;
  };
/*   const themeMessages = (theme) => {
    let res = null;
    switch (theme) {
      case 'dark':
        res = 'light';
        break;

      case 'dark':
        res = 'light';
        break;

      default:
        res = 'light';
    }
    return res;
  }; */

  const demoRoute = config.bIfDemo ? (
    <>
      <Route
        path={`/szlibstore/bibdeiscovery`}
        render={() => <DemoBibRetrieve {...props} />}
        exact
      />
    </>
  ) : (
    <></>
  );

  return (
    <IntlProvider
      locale={defaultLang}
      messages={handleMessages(lang)}
      theme={theme}>
      <BrowserRouter>
        <Suspense fallback={<div>载入中...</div>}>
          <Route
            path={`/`}
            render={() => <Home {...props} lang={lang} theme={theme} />}
            exact
          />
          {/* <Route
                  path={`/`}
                  render={() => <BibRetrieve {...props} lang={lang} theme={theme} />}
                  
                  exact  /> */}

          {/* /bibdeiscovery?searchKey=title&searchValue=*&limitType=0&booktype=0&offset=1&limit=20&aggs=classno,subject,author,type,pub_date,publish,&sortfld=title&sortWay=0 */}

          {config.lasname === 'ulas' && (
            <Route
              path={`/bibdeiscovery`}
              render={() => <ULAS {...props} />}
              exact
            />
          )}

          {config.lasname === 'openlas' && (
            <Route
              path={`/bibdeiscovery`}
              render={() => <BibRetrieve {...props} />}
              exact
            />
          )}
          <Route
            path={'/clcdeiscovery'}
            render={() => <ClcRetrieve {...props} />}
            exact
          />
          <Route
            path={'/newbook'}
            render={() => <NewBooks {...props} />}
            exact
          />
          <Route
            path={'/hotdeiscovery'}
            render={() => <HotBorrow {...props} />}
            exact
          />
          <Route path={'/notice'} render={() => <Notice {...props} />} exact />
{/*           <Route
            path={`/bibdeiscadvance`}
            render={() => <BibRetrAdvance {...props} />}
            exact
          /> */}
          <Route path={`/link`} render={() => <Link {...props} />} exact />

          <Route
            path={`/mylibrary/:func`}
            render={() => <MyLibrary {...props} />}
          />
          <Route
            path={`/detailpage/:instId`}
            render={() => (
              <DetailPage
                parLibMember={parLibMember}
                parLocals={parLocals}
                parDocCirculationTypes={parDocCirculationTypes}
                holdingStatus={holdingStatus}
                {...props}
                theme={theme}
              />
            )}
          />
          <Route
            path={`/detail/:instId`}
            render={() => <FakeDetail {...props} theme={theme} />}
          />

          <Route
            path={`/login/:return`}
            render={() => <RdrLogin {...props} />}
          />

          <Route
            path={`/metalspStore`}
            render={() => <metalspStore {...props} />}
          />

          <Route path={`/logout`} render={() => <RdrLogout {...props} />} />

          <Route
            path={`/techlib/digitaltwins`}
            render={() => <DigitalTwins {...props} />}
          />

          <Route path={`/tagcloud`} render={() => <TagCloud {...props} />} />

          {/* EditPwd */}

          {demoRoute}
        </Suspense>
      </BrowserRouter>
    </IntlProvider>
  );
};

export default Application;
